import Lozenge from '@atlaskit/lozenge';
import React from 'react';
import RichTooltip from "../../../../primitives/RichTooltip";
import { LozengeList } from "./HeaderLozenges.styles";
export var HeaderLozengeItem = function HeaderLozengeItem(_ref) {
  var lozenge = _ref.lozenge;
  var label = lozenge.label,
      _lozenge$isBold = lozenge.isBold,
      isBold = _lozenge$isBold === void 0 ? false : _lozenge$isBold,
      _lozenge$appearance = lozenge.appearance,
      appearance = _lozenge$appearance === void 0 ? 'default' : _lozenge$appearance,
      _lozenge$tooltipConte = lozenge.tooltipContent,
      tooltipContent = _lozenge$tooltipConte === void 0 ? null : _lozenge$tooltipConte;
  var lozengeContent = /*#__PURE__*/React.createElement(Lozenge, {
    appearance: appearance,
    isBold: isBold
  }, label);

  if (tooltipContent) {
    return /*#__PURE__*/React.createElement("li", {
      key: label
    }, /*#__PURE__*/React.createElement(RichTooltip, {
      content: tooltipContent
    }, lozengeContent));
  }

  return /*#__PURE__*/React.createElement("li", {
    key: label
  }, lozengeContent);
};

var HeaderLozenges = function HeaderLozenges(_ref2) {
  var lozenges = _ref2.lozenges;

  if (!lozenges.length) {
    return null;
  }

  return /*#__PURE__*/React.createElement(LozengeList, null, lozenges.map(function (lozenge) {
    return /*#__PURE__*/React.createElement(HeaderLozengeItem, {
      key: lozenge.label,
      lozenge: lozenge
    });
  }));
};

export default HeaderLozenges;